module.exports = {
  reserveApiUrl: "https://api-reserve.wanderinglabs.com"
};
